// extracted by mini-css-extract-plugin
export var expandIcon = "fy_vJ";
export var rotated = "fy_vK";